import * as React from 'react'
import * as CONFIG from '.'
import BuildFinal from '../routes/BuildKnowledgeV2/BuildFinal'
import BuildMultiDocumentsSection from '../routes/BuildKnowledgeV2/Step2/BuildMultiDocumentsSection'
import BuildSummariseDocumentsSection from '../routes/BuildKnowledgeV2/Step3/SummariseDocumentOptions'
import SummariseDocuments from '../routes/BuildKnowledgeV2/Step3/SummariseDocuments'
import GenerateKnowledge from '../routes/BuildKnowledgeV2/Step5/GenerateKnowledge'
import GenerateQna from '../routes/BuildKnowledgeV2/Step5/GenerateQna'
import DashboardQuizzes from '../routes/Dashboard/pages/DashboardQuizzes/DashboardQuizzes'

import MatchedUnmatchedQuestions from '../routes/Dashboard/pages/MatchedUnmatchedQuestions'
import QuizAnalyticsExportSubmission from '../routes/Dashboard/pages/QuizAnalyticsExportSubmission/QuizAnalyticsExportSubmission'
import QuizQuestionBreakdown from '../routes/Dashboard/pages/QuizQuestionBreakdown/QuizQuestionBreakdown'
import Integrations from '../routes/Integration/Integrations'
import LmsIntegration from '../routes/Integration/LmsIntegration'
import AllKnowledge from '../routes/Knowledge/AllKnowledge/AllKnowledge'
import ArchivedKnowledge from '../routes/Knowledge/ArchivedKnowledge/ArchivedKnowledge'
import GenerateQuestions from '../routes/Knowledge/GenerateQuestions/GenerateQuestions'
import ManageAccessRights from '../routes/Knowledge/ManageAccessRights/ManageAccessRights'
import ManageKnowledgeGroup from '../routes/Knowledge/ManageKnowledgeGroup/ManageKnowledgeGroup'
import ExercisesGrid from '@/routes/Exercises/ExercisesGrid'
import ExercisesGridArchive from '@/routes/Exercises/ExercisesGridArchive'
import CreateQuizFromQuestionId from '../routes/Quizzes/CreateQuizFromDocument/CreateQuizFromQuestionId'
import EditCreateQuiz from '../routes/Quizzes/EditCreateQuiz'
import { ImportFilePreview } from '../routes/Quizzes/ImportQuestionBank/ImportFilePreview'
import ImportQuestionBank from '../routes/Quizzes/ImportQuestionBank/ImportQuestionBank'
import ImportQuiz from '../routes/Quizzes/ImportQuiz/ImportQuiz'
import CreateEditQuestionBank from '../routes/Quizzes/QuizQuestionBank/CreateEditQuestionBank'
import QuizSumbmissionDetails from '../routes/Quizzes/QuizSubmissionList/QuizSubmissionDetails'
import QuizzesAllReviewRequestById from '../routes/Quizzes/QuizzesAllReviewRequestById/QuizzesAllReviewRequestById'
import QuizzesAllSubmissionsById from '../routes/Quizzes/QuizzesAllSubmissionsById/QuizzesAllSubmissionsById'
import UpdateClasses from '../routes/Users/partials/Classes/UpdateClasses'
import UpdateLearnerGroup from '../routes/Users/partials/LearnerGroup/UpdateLearnerGroup'
import UploadListOfUsers from '../routes/Users/partials/Learners/UploadListOfUsers'
import Support from './../routes/Support/Support'
import QuizessPendingReview from '../routes/Quizzes/QuizessPendingReviews/QuizessPendingReview'
import UpdateLearningOutcome from '../routes/BuildKnowledgeV2/learing-outcomes/UpdateLearningOutcome'

import ManagePlan from '../routes/ManagePlan'
import BotResponses from '@/routes/BotResponses'
import LearnerQuestions from '@/routes/LearnerQuestions'
import ManageKeyPhrase from '../routes/ManageKeyPhrases/ManageKeyPhrase'
import SetUpChat from '../routes/Knowledge/SetUpChat/SetUpChat'
import LearnerConversations from '@/routes/Dashboard/pages/LearnerConversations/LearnerConversations'
import OrganisationDashboard from '../routes/OrganisationDashboard/OrganisationDashboard'
import ImportLmsContent from '@/routes/Knowledge/ImportLmsContent'

const ToolkitGuidedImportQuiz = React.lazy(
  () => import('../routes/TeachersToolkit/pages/CreateGuidedQuiz'),
)
const ToolkitSelectPages = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/CreateSmartQuiz/step2/ToolkitSelectPages'
    ),
)
const ToolkitProcessDocument = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/CreateSmartQuiz/step3/ToolkitProcessDocuments'
    ),
)
const ReviewQuizQuestions = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/CreateSmartQuiz/step4/ToolkitReviewQuizQuestions'
    ),
)

const ToolkitSummariseLearningOutcome = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/LearningOutcomes/step3/SummariseLearningOutcome'
    ),
)

const ToolkitSummariseSmartQuiz = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/CreateSmartQuiz/step3/SummariseSmartQuizDocuments'
    ),
)

const ToolkitGenerateQueAns = React.lazy(
  () => import('../routes/TeachersToolkit/pages/GenerateQueAns'),
)
const ToolkitGenerateQnaSelectPages = React.lazy(
  () =>
    import('../routes/TeachersToolkit/pages/GenerateQueAns/step2/SelectPages'),
)
const ToolkitGenQnaProcessDocument = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/GenerateQueAns/step3/ProcessDocumentsPage'
    ),
)
const ToolkitGenerateKnowledgeSummarise = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/GenerateQueAns/step3/SummariseGenerateKnowledge'
    ),
)
const ToolkitGenerateQna = React.lazy(
  () =>
    import('../routes/TeachersToolkit/pages/GenerateQueAns/step5/GenerateQna'),
)
const ToolkitGenerateQnaFinal = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/GenerateQueAns/ToolkitGenerateQnaFinal'
    ),
)
const ToolkitSummariseDocuments = React.lazy(
  () => import('../routes/TeachersToolkit/pages/SummariseDocuments'),
)
const ToolkitSelectPagesToSummarise = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/SummariseDocuments/step2/ToolkitSelectPagesToSummarise'
    ),
)
const ToolkitSummariseMultipleOrSingleFile = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/SummariseDocuments/step3/ToolkitSummariseMultipleOrSingleFile'
    ),
)
const ToolkitSummariseDocFinal = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/SummariseDocuments/ToolkitSummariseDocFinal'
    ),
)
const ToolkitGenerateLearningOutcomes = React.lazy(
  () => import('../routes/TeachersToolkit/pages/LearningOutcomes'),
)
const ToolkitGenerateLearningOutcomesSelectPages = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/LearningOutcomes/step2/ToolkitGenerateLearningOutcomes'
    ),
)
const ToolkitGenerateLearningOutcomesProcessDocument = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/LearningOutcomes/step3/GenLearningOutcomesProcessDocs'
    ),
)
const ToolkitReviewLearningOutcomes = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/LearningOutcomes/step4/ToolkitReviewLearningOutcomes'
    ),
)
const ToolkitLearningOutcomesFinal = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/LearningOutcomes/LearningOutcomesFinal'
    ),
)
const SetupContextualisedChat = React.lazy(
  () => import('../routes/TeachersToolkit/pages/SetupContextualisedChat'),
)
const SetupContextualisedChatWaiting = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/SetupContextualisedChat/SetupContextualisedChatWaiting'
    ),
)
const SetupContextualisedChatFinal = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/SetupContextualisedChat/SetupContextualisedChatFinal'
    ),
)
const UsageTrends = React.lazy(
  () => import('../routes/Dashboard/pages/UsageTrends/UsageTrends'),
)
const UserNameEmail = React.lazy(
  () =>
    import('../routes/Dashboard/pages/UserSessionDetails/UserSessionDetail'),
)
const UserSessions = React.lazy(
  () => import('../routes/Dashboard/pages/UserSessions/UserSessions'),
)
const Knowledge = React.lazy(() => import('../routes/Knowledge'))
const UploadDocuments = React.lazy(
  () => import('../routes/Knowledge/UploadDocuments/UploadDocuments'),
)
const UploadUrl = React.lazy(
  () => import('../routes/Knowledge/UploadUrl/UploadUrl'),
)
const GenerateAnswers = React.lazy(
  () => import('../routes/Knowledge/GenerateAnswers/GenerateAnswers'),
)
//
const KnowledgeCreateFromScratch = React.lazy(
  () =>
    import(
      '../routes/Knowledge/KnowledgeCreateFromScratch/KnowledgeCreateFromScratch'
    ),
)
const ConversationFlow = React.lazy(
  () => import('../routes/ConversationFlow/ConversationFlow'),
)
const IntegratedSources = React.lazy(
  () =>
    import('../routes/TeachersToolkit/pages/Shared/IntegratedSources/index'),
)

const ChangeOrganisation = React.lazy(
  () => import('../routes/ChangeOrganisation/ChangeOrganisation'),
)
const Forms = React.lazy(() => import('../routes/Forms'))
const Channels = React.lazy(() => import('../routes/Channels/Channels'))
const Users = React.lazy(() => import('../routes/Users/Users'))
const Notifications = React.lazy(
  () => import('../routes/Notifications/Notifications'),
)
const SwitchAgent = React.lazy(
  () => import('../routes/SwitchAgent/SwitchAgent'),
)
const QuizDetail = React.lazy(
  () => import('../routes/Dashboard/pages/QuizDetail/QuizActivities'),
)
const QuizDetailByUser = React.lazy(
  () => import('../routes/Dashboard/pages/QuizDetailByUser/QuizDetailByUser'),
)

const Dashboard = React.lazy(
  () => import('../routes/Dashboard/pages/Index/Dashboard'),
)
const UploadedDocumentById = React.lazy(
  () => import('../routes/UploadedDocuments/DocumentDetailById'),
)

const DocumentSections = React.lazy(
  () => import('../routes/DocumentSections/DocumentSections'),
)

const ExportQuestionBank = React.lazy(
  () => import('../routes/Quizzes/ExportQuestionBank/ExportQuestionBank'),
)
const CreateSmartQuiz = React.lazy(
  () =>
    import(
      '../routes/TeachersToolkit/pages/CreateSmartQuiz/ToolkitCreateSmartQuiz'
    ),
)

const Discussion = React.lazy(
  () => import('../routes/Dashboard/pages/Discussion/Discussion'),
)

export const appRoutes = [
  { path: CONFIG.USAGETRENDS, isHeader: true, component: UsageTrends },
  {
    path: CONFIG.KNOWLEDGE_SETUP,
    isHeader: true,
    component: SetUpChat,
  },
  {
    path: CONFIG.USAGETRENDS_USERSESSIONS,
    isHeader: true,
    component: UserSessions,
  },
  {
    path: CONFIG.USAGETRENDS_USERSESSIONS_EMAILORUSERNAME,
    isHeader: true,
    component: UserNameEmail,
  },
  {
    path: CONFIG.LEARNER_CONVERSATIONS,
    isHeader: true,
    component: LearnerConversations,
  },
  { path: CONFIG.KNOWLEDGE, isHeader: true, component: Knowledge },
  {
    path: CONFIG.KNOWLEDGE_UPLOAD_DOCUMENTS,
    isHeader: true,
    component: UploadDocuments,
  },
  {
    path: CONFIG.KNOWLEDGE_GENERATE_QUESTIONS,
    isHeader: true,
    component: GenerateQuestions,
  },
  {
    path: CONFIG.KNOWLEDGE_GENERATE_ANSWERS,
    isHeader: true,
    component: GenerateAnswers,
  },
  { path: CONFIG.KNOWLEDGE_ALL, isHeader: true, component: AllKnowledge },
  {
    path: CONFIG.KNOWLEDGE_ARCHIVED,
    isHeader: true,
    component: ArchivedKnowledge,
  },
  {
    path: CONFIG.USERGROUP_CLASS_ACCESS,
    isHeader: true,
    component: ManageAccessRights,
  },
  {
    path: CONFIG.KNOWLEDGE_UPLOAD_URL_DOCUMENTS,
    isHeader: true,
    component: UploadUrl,
  },
  {
    path: CONFIG.KNOWLEDGE_KNOWLEDGE_CREATE_FROM_SCRATCH,
    isHeader: true,
    component: KnowledgeCreateFromScratch,
  },
  {
    path: CONFIG.KNOWLEDGE_IMPORT_LMS_CONTENT,
    isHeader: true,
    component: ImportLmsContent,
  },
  {
    path: CONFIG.KNOWLEDGE_CONVERSATION_FLOW,
    isHeader: true,
    component: ConversationFlow,
  },
  { path: CONFIG.FORMS, isHeader: true, component: Forms },
  { path: CONFIG.CHAT_CUSTOMISATION, isHeader: true, component: Channels },
  { path: CONFIG.USER_MANAGEMENT, isHeader: true, component: Users },
  { path: CONFIG.NOTIFICATION, isHeader: true, component: Notifications },
  { path: CONFIG.SWITCHAGENT, isHeader: true, component: SwitchAgent },
  { path: CONFIG.QUIZZDETAILSBYID, isHeader: true, component: QuizDetail },
  {
    path: CONFIG.QUIZDETAILBYUSER,
    isHeader: true,
    component: QuizDetailByUser,
  },
  {
    path: CONFIG.DOCUMENTDETAILBYID,
    isHeader: true,
    component: UploadedDocumentById,
  },
  {
    path: CONFIG.MATCHED_UNMATCHED_QUESTIONS,
    isHeader: true,
    component: MatchedUnmatchedQuestions,
  },
  { path: CONFIG.REPORTS_QUIZZES, isHeader: true, component: DashboardQuizzes },
  { path: CONFIG.ONBOARD, isHeader: true, component: Dashboard },
  {
    path: CONFIG.KNOWLEDGE_KEYPHRASES,
    isHeader: true,
    component: ManageKeyPhrase,
  },
  {
    path: CONFIG.DOCUMENT_SECTIONS,
    isHeader: true,
    component: DocumentSections,
  },
  {
    path: CONFIG.MANAGEKNOWLEDGEGROUP,
    isHeader: true,
    component: ManageKnowledgeGroup,
  },
  { path: CONFIG.SUPPORT, isHeader: true, component: Support },
  { path: CONFIG.SUPPORT_SUB_PATH, isHeader: true, component: Support },
  { path: CONFIG.UPDATE_CLASS, isHeader: true, component: UpdateClasses },
  {
    path: CONFIG.UPDATE_LEARNER_GROUP,
    isHeader: true,
    component: UpdateLearnerGroup,
  },
  {
    path: CONFIG.UPLOAD_LIST_OF_USERS,
    isHeader: true,
    component: UploadListOfUsers,
  },
  { path: CONFIG.GET_QUIZ_BYID, isHeader: true, component: EditCreateQuiz },
  { path: CONFIG.EXERCISES, isHeader: true, component: ExercisesGrid },
  {
    path: CONFIG.EXERCISES_ARCHIVE,
    isHeader: true,
    component: ExercisesGridArchive,
  },
  {
    path: CONFIG.EDIT_QUESTION_BANK,
    isHeader: true,
    component: CreateEditQuestionBank,
  },
  {
    path: CONFIG.CREATE_QUESTION_BANK,
    isHeader: true,
    component: CreateEditQuestionBank,
  },
  {
    path: CONFIG.EDIT_QUESTIONS_BANK,
    isHeader: true,
    component: CreateEditQuestionBank,
  },
  {
    path: CONFIG.INTEGRATION_MANAGEMENT,
    isHeader: true,
    component: Integrations,
  },
  {
    path: CONFIG.ORGANISATION_SUPPORT,
    isHeader: true,
    component: Support,
  },
  { path: CONFIG.INTEGRATION_TYPE, isHeader: true, component: LmsIntegration },
  { path: CONFIG.IMPORT_QUIZ, isHeader: true, component: ImportQuiz },
  {
    path: CONFIG.CREATE_QUIZ_FROM_QUESTION_ID,
    isHeader: true,
    component: CreateQuizFromQuestionId,
  },
  {
    path: CONFIG.IMPORTQUESTIONBANK_PREVIEW,
    isHeader: true,
    component: ImportFilePreview,
  },
  {
    path: CONFIG.IMPORTQUESTIONBANK_PREVIEWS_TAG,
    isHeader: true,
    component: CreateEditQuestionBank,
  },
  {
    path: CONFIG.IMPORTQUESTIONBANK_PREVIEWS_QUESTIONS,
    isHeader: true,
    component: CreateEditQuestionBank,
  },
  {
    path: CONFIG.IMPORTQUESTIONBANK,
    isHeader: true,
    component: ImportQuestionBank,
  },
  {
    path: CONFIG.QUIZZALLSUBMISSIONBYID,
    isHeader: true,
    component: QuizzesAllSubmissionsById,
  },
  {
    path: CONFIG.QUIZZALLREVIEWREQUESTSBYID,
    isHeader: true,
    component: QuizzesAllReviewRequestById,
  },
  {
    path: CONFIG.QUIZZSUBMISSIONBYSUBMISSIONID,
    isHeader: true,
    component: QuizSumbmissionDetails,
  },
  {
    path: CONFIG.QUIZZQUESTIONBREAKDOWNBYID,
    isHeader: true,
    component: QuizQuestionBreakdown,
  },
  {
    path: CONFIG.REPORTS_QUIZZES_ALL_SUBMISSIONS,
    isHeader: true,
    component: QuizAnalyticsExportSubmission,
  },
  {
    path: CONFIG.BUILD_MULTI_DOCUMENTS_SECTION,
    isHeader: true,
    component: BuildMultiDocumentsSection,
  },
  {
    path: CONFIG.BUILD_SUMMARISE_MULTI_DOCUMENTS_SECTION,
    isHeader: true,
    component: SummariseDocuments,
  },
  {
    path: CONFIG.BUILD_SUMMARISE_DOCUMENT,
    isHeader: true,
    component: BuildSummariseDocumentsSection,
  },
  {
    path: CONFIG.GENERATE_KNOWLEDGE,
    isHeader: true,
    component: GenerateKnowledge,
  },
  { path: CONFIG.GENERATE_QNA, isHeader: true, component: GenerateQna },
  { path: CONFIG.BUILD_FINAL, isHeader: true, component: BuildFinal },
  {
    path: CONFIG.EXERCISES_REVIEW,
    isHeader: true,
    component: QuizessPendingReview,
  },
  {
    path: CONFIG.LEARNING_OUTCOMES_UPDATE,
    isHeader: true,
    component: UpdateLearningOutcome,
  },
  { path: CONFIG.OVERVIEW, isHeader: true, component: Dashboard },
  {
    path: CONFIG.ORGANISATION_DASHBOARD,
    isHeader: true,
    component: OrganisationDashboard,
  },
  { path: CONFIG.PLAN_MANAGEMENT, isHeader: true, component: ManagePlan },
  {
    path: CONFIG.CREATE_SMART_QUIZ,
    isHeader: true,
    component: CreateSmartQuiz,
  },
  {
    path: CONFIG.SMART_QUIZ_SELECT_PAGES,
    isHeader: true,
    component: ToolkitSelectPages,
  },
  {
    path: CONFIG.SMART_QUIZ_PROCESS_DOCUMENTS,
    isHeader: true,
    component: ToolkitProcessDocument,
  },
  {
    path: CONFIG.TOOLKIT_SMART_QUIZ_SUMMARISE_DOCUMENTS,
    isHeader: true,
    component: ToolkitSummariseSmartQuiz,
  },
  {
    path: CONFIG.REVIEW_QUIZ_QUESTIONS,
    isHeader: true,
    component: ReviewQuizQuestions,
  },
  {
    path: CONFIG.GUIDED_QUIZESS_IMPORT,
    isHeader: true,
    component: ToolkitGuidedImportQuiz,
  },
  {
    isHeader: true,
    component: ToolkitGenerateQueAns,
    path: CONFIG.TOOLKIT_GENERATE_QNA_UPLOAD_DOC,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_QNA_SELECT_PAGES,
    isHeader: true,
    component: ToolkitGenerateQnaSelectPages,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_QNA_PROCESS_DOCUMENTS,
    isHeader: true,
    component: ToolkitGenQnaProcessDocument,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_QNA_SUMMARISE_DOCUMENTS,
    isHeader: true,
    component: ToolkitGenerateKnowledgeSummarise,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_QNA,
    isHeader: true,
    component: ToolkitGenerateQna,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_QNA_FINAL,
    isHeader: true,
    component: ToolkitGenerateQnaFinal,
  },
  {
    path: CONFIG.TOOLKIT_SUMMARISE_DOCUMENTS,
    isHeader: true,
    component: ToolkitSummariseDocuments,
  },
  {
    path: CONFIG.TOOLKIT_SUMMARISE_DOCUMENTS_SELECT_PAGES,
    isHeader: true,
    component: ToolkitSelectPagesToSummarise,
  },
  {
    path: CONFIG.TOOLKIT_SUMMARISE_DOCUMENTS_SINGLE_MULTIPLE,
    isHeader: true,
    component: ToolkitSummariseMultipleOrSingleFile,
  },
  {
    path: CONFIG.TOOLKIT_SUMMARISE_DOCUMENTS_FINAL,
    isHeader: true,
    component: ToolkitSummariseDocFinal,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_LEARNING_OUTCOMES,
    isHeader: true,
    component: ToolkitGenerateLearningOutcomes,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_LEARNING_OUTCOMES_SUMMARISE_DOCUMENTS,
    isHeader: true,
    component: ToolkitSummariseLearningOutcome,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_LEARNING_OUTCOMES_SELECT_PAGES,
    isHeader: true,
    component: ToolkitGenerateLearningOutcomesSelectPages,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_LEARNING_OUTCOMES_PROCESS_DOCS,
    isHeader: true,
    component: ToolkitGenerateLearningOutcomesProcessDocument,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_LEARNING_OUTCOMES_REVIEW,
    isHeader: true,
    component: ToolkitReviewLearningOutcomes,
  },
  {
    path: CONFIG.TOOLKIT_GENERATE_LEARNING_OUTCOMES_FINAL,
    isHeader: true,
    component: ToolkitLearningOutcomesFinal,
  },
  {
    path: CONFIG.TOOLKIT_SETUP_CONTEXTUALISED_CHAT,
    isHeader: true,
    component: SetupContextualisedChat,
  },
  {
    path: CONFIG.TOOLKIT_SETUP_CONTEXTUALISED_CHAT_WAITING,
    isHeader: true,
    component: SetupContextualisedChatWaiting,
  },
  {
    path: CONFIG.TOOLKIT_SETUP_CONTEXTUALISED_CHAT_FINAL,
    isHeader: true,
    component: SetupContextualisedChatFinal,
  },
  {
    path: CONFIG.DISCUSSION,
    isHeader: true,
    component: Discussion,
  },
  {
    path: CONFIG.RESPONSES,
    isHeader: true,
    component: BotResponses,
  },
  {
    path: CONFIG.LEARNER_QUESTIONS,
    isHeader: true,
    component: LearnerQuestions,
  },
  {
    path: CONFIG.EXPORT_QUESTION_BANK,
    isHeader: true,
    component: ExportQuestionBank,
  },
  {
    path: CONFIG.INTEGRATED_SOURCES,
    isHeader: true,
    component: IntegratedSources,
  },
  {
    path: CONFIG.CHANGE_ORGANISATION,
    isHeader: true,
    component: ChangeOrganisation,
  },
]
